import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate} from "@angular/router";
import {AuthService} from "../_services/auth.service";
import {UserService} from '../../core/_services/user.service';
import {Observable} from "rxjs/Rx";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private auth: AuthService,
                private router: Router,
                public userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (route.routeConfig.path === 'newuser' || route.routeConfig.path === 'newbooking') {
            if (this.auth.loggedIn()) {
                this.router.navigate(['/book'], { queryParams: route.queryParams });
                return false;
            } else {
                return true;
            }
        } else if (route.routeConfig.path === 'newservice') {
            if (this.auth.loggedIn()) {
                return true;
            } else {
                this.router.navigate(['/book/newuser'], { queryParams: route.queryParams });
                return false;
            }
        } else if (this.auth.loggedIn()) {
            return true;
        } else {
            this.userService.redirectUrl = state.url;
            this.router.navigate(['/login']);
            return false;
        }
      }
}
